import { render, staticRenderFns } from "./MenuLeftItem.vue?vue&type=template&id=64b5e938&"
import script from "./MenuLeftItem.vue?vue&type=script&lang=js&"
export * from "./MenuLeftItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuLeftItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports